export const constant = {
  Add_Module: 'Add',
  Save_Menu: 'Save',
  Update_Menu: 'Update',
  yes: 'Yes',
  no: 'No'
};
